/*eslint-disable eqeqeq*/
import React from "react";
import { NavLink, withRouter } from "react-router-dom";
import "react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";
import CircularProgress from '@material-ui/core/CircularProgress';
import * as AppConstants from "../../../config/AppConstant";
// import "./sidebaryomi.css";
import ExpansionPanelComponent from "../../../shared/components/expansionPanel/expansionPanel";

const Sidebar = (props) => {
	const [expanded, setExpanded] = React.useState(`panel1`);
	const [selectedPath, setSelectedPath] = React.useState("/digital-product/selection/digital-bundle");
	const [isClick, setClick] = React.useState(false);
	const [subMenuExpanded, setSubMenuExpanded] = React.useState("");
	const [sidebarMenu, setSidebarMenu] = React.useState(1);
	const [dataSource, setdataSource] = React.useState([]);
	const [isDevNav, setisDevNav] = React.useState([]);
	const [dataSourceNew, setdataSourceNew] = React.useState([{
		"BrandName": "EXPLORE YOMI CONNECT",
		"Campaigns": "[{\"CampaignID\":\"cbcb5edf-f8a1-4013-8502-d674e5238\",\"CampaignName\":\"Practice Materials\"},{\"CampaignID\":\"dfd49ea5-2e1d-47b8-a3f8-5403c7631375\",\"CampaignName\":\"Email Marketing\"},{\"CampaignID\":\"cbcb5edf-f8a1-4013-8502-d674e52380\",\"CampaignName\":\"Social Media\"},{\"CampaignID\":\"cbcb5edf-f8a1-4013-8502-d674e52380c4\",\"CampaignName\":\"Direct Mail\"},{\"CampaignID\":\"cbcb5edf-f8a1-4013-8502-d674e523\",\"CampaignName\":\"Images. Logos\"},{\"CampaignID\":\"cbcb5edf-f8a1-4013-8502-d\",\"CampaignName\":\"Videos\"},{\"CampaignID\":\"cbcb5edf-f8a1-4013-8502-d674e52\",\"CampaignName\":\"Digital Assets\"},{\"CampaignID\":\"cbcb5edf-f8a1-4013-8502-d674e5\",\"CampaignName\":\"Pulblic Relations\"},{\"CampaignID\":\"cbcb5edf-f8a1-4013-8502-d674\",\"CampaignName\":\"Scripts & Talk Points\"},{\"CampaignID\":\"cbcb5edf-f8a1-4013-8502-d674\",\"CampaignName\":\"Presentations\"},{\"CampaignID\":\"cbcb5edf-f8a1-4013-8502-d67\",\"CampaignName\":\"Practice Education\"},{\"CampaignID\":\"cbcb5edf-f8a1-4013-8502-d6\",\"CampaignName\":\"FAQ's\"}]"
	}]);
	const [dataSourceAdmin, setdataSourceAdmin] = React.useState([]);
	const [dataSourceAdmin1, setdataSourceAdmin1] = React.useState([]);
	const [isLoading, setLoading] = React.useState(true);

	React.useEffect(() => {
		GetNavigationDataFromLocal();
		if (props.location.pathname == "/digital-product/selection/adbreak"
			|| props.location.pathname == "/dashboard"
			|| props.location.pathname == "/admin"
			|| props.location.pathname == "/product/add"
			|| props.location.pathname == "/assetdownloadreport") {
			props.closeSidebar()
		} else if (window.innerWidth >= 991) {
			props.handleMenu1()
		}
	}, [props.location.pathname]);


	const GetNavigationDataFromLocal = () => {
		let response = JSON.parse(localStorage.getItem('GetNav'))
		if (response != null && response.error == null) {
			setdataSource(response.object.data.BrandsNav)
			setLoading(false)
			if (response.object.data.AdminNav.AdminNav.length) {
				setdataSourceAdmin(response.object.data.AdminNav.AdminNav)
				setdataSourceAdmin1(response.object.data.AdminNav.SuperAdminNav)
				setisDevNav(response.object.data.AdminNav.DevNav)
				sessionStorage.setItem("IsDeveloper", response.object.data.AdminNav.DevNav.length ? true : false);
				localStorage.setItem("headerMenuAdmin", 1);
				setSidebarMenu(0)
			} else {
				localStorage.setItem("headerMenuAdmin", 0);
				setSidebarMenu(1)
			}

			response.object.data.BrandsNav.forEach((obj, index) => {
				if (props.location.pathname.includes(obj.BrandName) && !isClick) {
					setExpanded(`panel${index + 1}`);
					setClick(true);
				}

				JSON.parse(obj.Campaigns) && JSON.parse(obj.Campaigns).forEach((subObj, subIndex) => {
					if (props.location.pathname.includes(subObj.CampaignName) && !isClick) {
						setSubMenuExpanded(`subpanel-${index + 1}-${subIndex + 1}`);
						setClick(true);
					}

					obj.Products && obj.Products.forEach((childObj, childIndex) => {
						if (props.location.pathname.includes(childObj.ProductName) && !isClick) {
							setSubMenuExpanded(`subpanel-${index + 1}-${childIndex + 1}`);
							setClick(true);
						}
					});
				});
			});
		}
	}

	return (
		<section
			className={`left-sidebar ${props.isSidebarOpen ? "active" : ""}`}
			onClick={() => {
				const body = document.getElementsByTagName("body")[0];
				body.classList.add("active");
			}}>
			<PerfectScrollbar
				component='div'
				options={{
					wheelSpeed: 0.5,
					wheelPropagation: true,
					minScrollbarLength: 20,
					swipeEasing: true,
					handlers: ["click-rail", "drag-thumb", "keyboard", "wheel", "touch"],
				}}>
				{isLoading ? <div className='humburger-menu'><CircularProgress style={{ color: '#fff' }} /> </div> :
					<div>
						<div className='humburger-menu' onClick={props.handleMenu}>
							<span></span>
							<span></span>
							<span></span>
						</div>
						<nav>
							<ul>
								{sidebarMenu == 1 ? dataSource.map((obj, index) => {
									return (
										<li key={index} >
											<ExpansionPanelComponent
												title={<span>{obj.BrandName}</span>}
												className={`parent-nav`}
												summaryClassName={`${selectedPath === obj.BrandID ? 'active' : ''}`}
												icon={""}
												id={`panel${index + 1}`}
												expanded={expanded}
												controls={`panel${index + 1}`}
												focused={true}
												setExpanded={(value) => {
													setSelectedPath(obj.BrandID)
													AppConstants.SetLocalStorage('localStorageBrandID', obj.BrandID);
													AppConstants.SetLocalStorage('localStorageBrandName', obj.BrandName);
													props.history.push({ pathname: "/digital-product/selection" });
												}}>
												{JSON.parse(obj.Campaigns) &&
													!!JSON.parse(obj.Campaigns).length &&
													JSON.parse(obj.Campaigns).map((subObj, subIndex) => {
														return (
															<>{subObj.Products &&
																!!subObj.Products.length &&
																subObj.Products.map((menuobj, menuIndex) => {
																	return (
																		<NavLink
																			className={`subparent-nav  ${selectedPath === subObj.CampaignID ? 'active' : ''}`}
																			title={obj.PageURL}
																			to={{ pathname: menuobj.PageURL }}
																			onMouseEnter={() => {
																				const card = document.getElementById(menuobj.ProductID.toLowerCase().replace(" ", "-"));
																				if (card) { card.classList.add("active"); }
																			}}
																			onMouseLeave={() => {
																				const card = document.getElementById(menuobj.ProductID.toLowerCase().replace(" ", "-"));
																				if (card) { card.classList.remove("active"); }
																			}}
																			activeClassName='active'
																			onClick={() => {
																				setSelectedPath(`${subObj.CampaignID}`)
																				AppConstants.SetLocalStorage('localStorageCampaignID', subObj.CampaignID);
																				AppConstants.SetLocalStorage('localStorageCampaignName', subObj.CampaignName);
																				AppConstants.SetLocalStorage("localStorageBudgetDetail", menuobj.PageURL == "/digital-product/selection/location-selection" ? JSON.stringify([{ "budget": 1, "duration": 1 }]) : JSON.stringify([{ "budget": 1, "duration": "" }]))
																				AppConstants.SetLocalStorage("localStorageProductName", menuobj.ProductName)
																				AppConstants.SetLocalStorage("localStorageProductID", menuobj.ProductID)
																				AppConstants.SetLocalStorage("localStorageShowCopyText", menuobj.ShowCopyText)
																				AppConstants.SetLocalStorage("localStorageShowAddToCart", menuobj.ShowAddToCart)
																				AppConstants.SetLocalStorage("localStorageMenuPath", menuobj.MenuPath)
																				AppConstants.SetLocalStorage('localStorageOrderDetailsID', 0)
																				AppConstants.SetLocalStorage("localStorageISDirectMail", menuobj.ProductName == "Direct Mail" ? 1 : 0)
																				// localStorageProductName
																			}}
																			key={menuIndex}>
																			<span>•&nbsp;&nbsp;{menuobj.ProductName}</span>
																		</NavLink>
																	);
																})}
															</>
														)
													})}
											</ExpansionPanelComponent>
										</li>
									);
								}) :
									<div>
										<>{
											<li key={0}>
												<ExpansionPanelComponent
													title={<span>Yomi</span>}
													className={"parent-nav"}
													summaryClassName={`${selectedPath === "BauschLom" ? 'active' : ''}`}
													icon={""}
													id={`panel${0 + 1}`}
													expanded={expanded}
													controls={`panel${0 + 1}`}
													setExpanded={(value) => {
														setExpanded("");
														setSelectedPath("BauschLom")
														setTimeout(() => {
															setExpanded(value);
														}, 500);
													}}>
													{dataSourceAdmin.map((subObj, subIndex) => {
														return (
															<li key={subIndex}>
																<ExpansionPanelComponent
																	title={<span>{subObj.Name}</span>}
																	className={"subparent-nav"}
																	summaryClassName={`${selectedPath === subObj.Name ? 'active' : ''}`}
																	icon={""}
																	id={`subpanel-${0 + 1}-${subIndex + 1}`}
																	expanded={subMenuExpanded}
																	controls={`subpanel-${0 + 1}-${subIndex + 1}`}

																	setExpanded={(value) => {
																		setSubMenuExpanded("");
																		setSelectedPath(subObj.Name)
																		setTimeout(() => {
																			setSubMenuExpanded(value);
																		}, 500);
																		props.history.push(`${subObj.path}`);
																	}}>
																	{JSON.parse(subObj.Menu) &&
																		!!JSON.parse(subObj.Menu).length &&
																		JSON.parse(subObj.Menu).map((menuobj, menuIndex) => {
																			return (
																				<NavLink
																					className={`child-nav  ${selectedPath === menuobj.Name ? 'active' : ''}`}
																					title={menuobj.ProductName}
																					to={{ pathname: menuobj.URL }}
																					onMouseEnter={() => {
																						const card = document.getElementById(menuobj.Name);
																						if (card) {
																							card.classList.add("active");
																						}
																					}}
																					onMouseLeave={() => {
																						const card = document.getElementById(menuobj.Name);
																						if (card) {
																							card.classList.remove("active");
																						}
																					}}
																					activeClassName='active'
																					onClick={() => {
																						setSelectedPath(`${menuobj.Name}`)
																					}}
																					key={menuIndex}>
																					<span >{menuobj.Name} </span>
																				</NavLink>
																			);
																		})}
																</ExpansionPanelComponent>
															</li>
														);

													})}
												</ExpansionPanelComponent>
											</li>
										}</>
										<>{
											<ExpansionPanelComponent
												title={<span>CoBrand</span>}
												className={"parent-nav"}
												summaryClassName={`${selectedPath === "CoBrand" ? 'active' : ''}`}
												icon={""}
												id={`panel${1 + 1}`}
												expanded={expanded}
												controls={`panel${1 + 1}`}
												setExpanded={(value) => {
													setExpanded("");
													setSelectedPath("CoBrand")
													setTimeout(() => {
														setExpanded(value);
													}, 500);
												}}>
												{dataSourceAdmin1.map((obj, subIndex) => {
													return (
														<li key={subIndex}>
															<ExpansionPanelComponent
																title={
																	<span dangerouslySetInnerHTML={{ __html: obj.Name }} />
																}
																className={"subparent-nav"}
																summaryClassName={`${selectedPath === obj.Name ? 'active' : ''}`}
																icon={""}
																id={`subpanel-${1 + 1}-${subIndex + 1}`}
																expanded={subMenuExpanded}
																controls={`subpanel-${1 + 1}-${subIndex + 1}`}

																setExpanded={(value) => {
																	setSelectedPath(obj.Name)
																	setSubMenuExpanded("");
																	setTimeout(() => {
																		setSubMenuExpanded(value);
																	}, 500);
																	props.history.push(`${obj.path}`);
																}}>

																{JSON.parse(obj.Menu) &&
																	!!JSON.parse(obj.Menu).length &&
																	JSON.parse(obj.Menu).map((subObj, menuIndex) => {
																		// props.history.push(`${obj.path}/${subObj.path}`)																		
																		return (
																			<NavLink
																				className={`child-nav  ${selectedPath === subObj.Name ? 'active' : ''}`}
																				title={obj.Name}
																				to={{ pathname: subObj.URL }}
																				onMouseEnter={() => {
																					const card = document.getElementById(
																						obj.Name
																							.toLowerCase()
																							.replace(" ", "-")
																					);

																					if (card) {
																						card.classList.add("active");
																					}
																				}}
																				onMouseLeave={() => {
																					const card = document.getElementById(
																						obj.Name
																							.toLowerCase()
																							.replace(" ", "-")
																					);
																					if (card) {
																						card.classList.remove("active");
																					}
																				}}
																				activeClassName='active'
																				onClick={() => {
																					setSelectedPath(`${subObj.Name}`)
																				}}
																				key={menuIndex}>
																				<span>{subObj.Name}</span>
																			</NavLink>
																		);
																	})}
															</ExpansionPanelComponent>
														</li>
													);

												})}
											</ExpansionPanelComponent>
										}
										</>
										<>{isDevNav.length &&
											<ExpansionPanelComponent
												title={<span>DevNav</span>}
												className={"parent-nav"}
												summaryClassName={`${selectedPath === "DevNav" ? 'active' : ''}`}
												icon={""}
												id={`panel${2 + 1}`}
												expanded={expanded}
												controls={`panel${2 + 1}`}
												setExpanded={(value) => {
													setExpanded("");
													setSelectedPath("DevNav")
													setTimeout(() => {
														setExpanded(value);
													}, 500);
												}}>
												{isDevNav.map((obj, subIndex) => {
													return (
														<li key={subIndex}>
															<ExpansionPanelComponent
																title={
																	<span dangerouslySetInnerHTML={{ __html: obj.Name }} />
																}
																className={"subparent-nav"}
																summaryClassName={`${selectedPath === obj.Name ? 'active' : ''}`}
																icon={""}
																id={`subpanel-${2 + 1}-${subIndex + 1}`}
																expanded={subMenuExpanded}
																controls={`subpanel-${2 + 1}-${subIndex + 1}`}

																setExpanded={(value) => {
																	setSelectedPath(obj.Name)
																	setSubMenuExpanded("");
																	setTimeout(() => {
																		setSubMenuExpanded(value);
																	}, 500);
																	props.history.push(`${obj.path}`);
																}}>

																{JSON.parse(obj.Menu) &&
																	!!JSON.parse(obj.Menu).length &&
																	JSON.parse(obj.Menu).map((subObj, menuIndex) => {
																		return (
																			<NavLink
																				className={`child-nav  ${selectedPath === subObj.Name ? 'active' : ''}`}
																				title={obj.Name}
																				to={{ pathname: subObj.URL }}
																				onMouseEnter={() => {
																					const card = document.getElementById(
																						obj.Name
																							.toLowerCase()
																							.replace(" ", "-")
																					);

																					if (card) {
																						card.classList.add("active");
																					}
																				}}
																				onMouseLeave={() => {
																					const card = document.getElementById(
																						obj.Name
																							.toLowerCase()
																							.replace(" ", "-")
																					);
																					if (card) {
																						card.classList.remove("active");
																					}
																				}}
																				activeClassName='active'
																				onClick={() => {
																					setSelectedPath(`${subObj.Name}`)
																				}}
																				key={menuIndex}>
																				<span>{subObj.Name}</span>
																			</NavLink>
																		);
																	})}
															</ExpansionPanelComponent>
														</li>
													);

												})}
											</ExpansionPanelComponent>
										}</>
									</div>
								}
							</ul>
						</nav>
					</div>
				}
			</PerfectScrollbar>
		</section>

	);
};

export default withRouter(Sidebar);
